var map = {
	"./shared/benchmarks/benchmark-percentile-chart/index.js": [
		16066,
		[
			3203,
			263,
			7510,
			6066
		]
	],
	"./shared/benchmarks/benchmarks-list/index.js": [
		70486,
		[
			3203,
			7510,
			486
		]
	],
	"./shared/benchmarks/benchmarks-selector/index.js": [
		74387,
		[
			3203,
			263,
			7510,
			6673,
			4387
		]
	],
	"./shared/benchmarks/config/index.js": [
		48631,
		[
			263,
			8631
		]
	],
	"./shared/benchmarks/hooks/index.js": [
		63325,
		[
			3325
		]
	],
	"./shared/benchmarks/screens/index.js": [
		34262,
		[
			263,
			4262
		]
	],
	"./shared/benchmarks/simple-store/index.js": [
		95383,
		[
			5383
		]
	],
	"./shared/copy-to-clipboard/index.js": [
		50361,
		[
			7510,
			361
		]
	],
	"./views/index.js": [
		55875,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86864;
module.exports = webpackAsyncContext;